import React from 'react'
import './TaskType.scss'
import { LuxSelect } from '@lux/wardrobe-lib'
import { useIntl } from 'react-intl'
import SectionItem from '@/app/components/Layout/SectionItem/SectionItem'
import { FormBase, SubActivityTypeForm } from '@/app/models/new-activity-form'
import { Analytics } from '@Techedge/digitalportal-shared'

const analyticsPageTypeMap = {
    communication: 'Task:Communication:Creation',
    serviceRequest: 'Task:ServiceRequest:Creation',
    manainancePhoto: 'Task:MantainancePhoto:Creation',
    highQualityPhoto: 'Task:HighQualityPhoto:Creation',
}

export const PhTaskType = (props: FormBase<SubActivityTypeForm>) => {
    const componentClass = 'smart-new-activity-task-type'
    const { form, onSetForm, typeList } = props
    const intl = useIntl()

    return (
        <div className={componentClass}>
            <SectionItem>
                <LuxSelect
                    value={form.photoType}
                    onChangeCallback={(value) => {
                        Analytics._sendAnalyticsLinkEvent(
                            'Activities',
                            analyticsPageTypeMap[value],
                            'Static'
                        )
                        onSetForm({ ...form, photoType: value })
                    }}
                    mandatory
                    label={intl.formatMessage({
                        id: 'ph2.photographic_task.type.select',
                        defaultMessage: 'Photographic task type',
                    })}
                    options={typeList?.map((type) => ({
                        ...type,
                        label: intl.formatMessage({
                            id: `ph2.photographic_task.type.${type.label}`,
                            defaultMessage: type.label,
                        }),
                    }))}
                    placeholder={intl.formatMessage({
                        id: 'ph2.photographic_task.type.select.placeholder',
                        defaultMessage: 'Select photographic task type',
                    })}
                    additionalProps={{
                        appendTo: 'self',
                    }}
                />
            </SectionItem>
        </div>
    )
}

export default PhTaskType
